const { default: axiosIns } = require('@/libs/axios')

const GalleryService = {
  // GET - GalleryApiController
  async getVideos(page, accountId) {
    return axiosIns.get(`/gallery/videos?accountId=${accountId}`, {
      params: {
        page,
      },
    }).then(response => response.data)
  },
  // POST - GalleryApiController
  async getCreatives(filterModel, accountId) {
    return axiosIns.post(`/gallery/creatives?accountId=${accountId}`, filterModel).then(response => response.data)
  },
  // POST - GalleryApiController
  async createCreative(model, accountId) {
    return axiosIns.post(`/gallery/creatives/create?accountId=${accountId}`, model, {
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(response => response.data)
  },
  // PUT - GalleryApiController
  async updateCreative(id, model, accountId) {
    return axiosIns.put(`/gallery/creatives/${id}?accountId=${accountId}`, model).then(response => response.data)
  },
  async updateVideo(id, model, accountId) {
    return axiosIns.put(`/gallery/videos/${id}?accountId=${accountId}`, model).then(response => response.data)
  },
  // GET - GalleryApiController
  async getFormats(accountId) {
    return axiosIns.get(`/gallery/formats?accountId=${accountId}`).then(response => response.data)
  },
}

export default GalleryService
